<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.inventory_control')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('inventory.archive_inventory')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 d-flex justify-content-between flex-nowrap">
        <div class="d-flex flex-wrap">
          <div class="form-group mr-1">
            <input id='dtSearch' type='text' class='form-control' v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <div class="dropdown">
              <button id='filterByStock' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{translations('inventory.all')}}
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" v-on:click='in_stock="all"; selectStock("all");'>{{translations('inventory.all')}}</a>
                <a class="dropdown-item" v-on:click='in_stock="exclude"; selectStock("exclude");'>{{translations('inventory.excluding_stock_0')}}</a>
                <a class="dropdown-item" v-on:click='in_stock="reserve"; selectStock("reserve");'>{{translations('inventory.excluding_stock_0_reserve')}}</a>
                <a class="dropdown-item" v-on:click='in_stock="only"; selectStock("only");'>{{translations('inventory.stock_0_only')}}</a>
                <a class="dropdown-item" v-on:click='in_stock="reserve_only"; selectStock("reserve_only");'>{{translations('inventory.reservation_only')}}</a>
              </div>
            </div>
          </div>
          <div class="form-group mr-3">
            <div class="dropdown">
              <button id='filterByClient' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getFilterTxt (master_mywarehouses, warehouse_id, 'name', translations('inventory.all_warehouses')) }}
                </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-on:click='warehouse_id=0;'>{{translations('inventory.all_warehouses')}}</a>
                <a class='dropdown-item' v-for='(item, i) in master_mywarehouses' :key='i' v-on:click='warehouse_id=item.id;'>{{ item.name }}</a>
              </div>
            </div>
          </div>
          <div class="form-group mr-3 d-flex align-items-center">
            <span class="text-nowrap mr-1">{{translations('inventory.reference_date')}}</span>
<!--            <input v-model="referenceAt" type="date" class="form-control" @blur='triggerDateFilter()' @focus="tempDateField = referenceAt">-->
            <input v-model="referenceAt" type="date" class="form-control">
          </div>
          <div class="form-group mr-2" v-for="(checkCondition, i) in translatedCheckConditions" :key='i'>
            <div class="form-check">
              <input class="form-check-input pointer-clickable" type="radio" :value="checkCondition.value" :id='checkCondition.id' v-model="selectedCheckCondition">
              <label class="form-check-label pointer-clickable" :for="checkCondition.id">
                {{checkCondition.name}}
              </label>
            </div>
          </div>
          <div class="form-group mr-2" v-for="(condition, i) in translatedConditions" :key="'condition_' + i">
            <div class="form-check">
              <input class="form-check-input pointer-clickable" type="checkbox" :value="condition.value" :id='condition.id' v-model="selectedConditions" :disabled="checkOpenCondition()">
              <label class="form-check-label pointer-clickable" :for="'condition_' + condition.id">
                {{condition.name}}
              </label>
            </div>
          </div>

          <div class="form-group mr-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{translations('inventory.display_all')}}
              </label>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch" :disabled="checkOpenSubmit()">{{translations('common.search')}}</button>
          </div>
          <div class="form-group">
            <input v-model="old_jan" type="text" class="form-control mr-1" :placeholder="translations('inventory.old_jan_code')">
            <div class="form-group mr-3">
              <div class="dropdown">
                <button id='filterByClient' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ getFilterTxt (master_mywarehouses_old, old_warehouse_id, 'name', translations('inventory.warehouse_selection')) }}
                  </button>
                <div class="dropdown-menu">
                  <a class='dropdown-item' v-on:click='old_warehouse_id=0'>{{ translations('inventory.warehouse_selection') }}</a>
                  <a class='dropdown-item' v-for='(item, i) in master_mywarehouses_old' :key='i' v-on:click='old_warehouse_id=item.id'>{{ item.name }}</a>
                </div>
              </div>
            </div>
            <span class="text-nowrap mx-1">→</span>
            <input v-model="new_jan" type="text" class="form-control" :placeholder="translations('inventory.new_jan_code')">
            <span class="text-nowrap ml-2 mr-1">{{ translations('inventory.number_replacements') }}</span>
            <input v-model="jan_change_quantity" type="text" @input="numbers('jan_change_quantity')" class="form-control number-container mr-1" style="width:80px;">
            <input v-model="replacementAt" type="date" class="form-control">
            <button class="btn btn-primary btn-sm ml-2" type="button" @click="changeJanCode" :disabled="!old_jan || !new_jan || !old_warehouse_id || !jan_change_quantity || !jan_change_done">{{ translations('inventory.jan_replacement') }}</button>
          </div>
        </div>
        <div class="d-flex">
          <div class="form-group">
            <button class="btn btn-sm btn-link p-0 decoration-underline margin-right-10" type="button" data-toggle="modal" data-target="#ArchiveStockDownloadModal">{{ translations('inventory.download_csv') }}</button>
          </div>
          <div class="form-group">
            <a href="/inventories" class="btn btn-sm btn-link decoration-underline" target="_blank">{{ translations('inventory.inventory') }}<i class="fas fa-external-link-alt"></i></a>
          </div>
          <div class="form-group">
            <button class="btn btn-sm btn-secondary" type="button" data-toggle="modal" data-target="#ArchiveStockClosingModal">{{ translations('inventory.closing_process') }}</button>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div class="form-inline">
          <button class="btn btn-primary btn-sm" type="button" data-toggle="modal" data-target="#productsConstructModal" :disabled="checkOpenDetachSet()">{{ translations('inventory.product_assembly') }}</button>
          <button class="btn btn-primary btn-sm ml-2" type="button" v-on:click="openModalDetachSet" :disabled="checkOpenDetachSet()">{{ translations('inventory.product_disassembly') }}</button>
        </div>
        <div class="form-inline">
          <h5 class="font-weight-bold mb-3 mr-2">{{ translations('inventory.total_stock_quantity') }}： {{ this.sumTotalQuantity.toLocaleString() }}  </h5>
          <h5 class="font-weight-bold mb-3">{{ translations('inventory.total_inventory_cost') }}： {{ this.totalAmount.toLocaleString() }}  </h5>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover"
          item-key="name"
          :headers="[
            { text: translations('inventory.division'), value: 'in_stock_status' },
            { text: translations('inventory.maker'), value: 'maker_name' },
            { text: translations('inventory.jan_code'), value: 'ean_code' },
            { text: translations('inventory.model'), value: 'model' },
            { text: translations('inventory.available_quantity'), value: 'quantity' },
            { text: translations('reserve.reserve_quantity'), value: 'reserve_quantity'},
            { text: translations('inventory.unit_price'), value: 'original_price_jpy' },
            { text: translations('inventory.inventory_cost'), value: 'original_price_jpy_total' },
            { text: translations('inventory.warehouse'), value: 'warehouse_name' },
            { text: translations('inventory.order_date'), value: 'date_out_stock', class: (Number(checkSelectedCondition) !== 0 && Number(checkSelectedCondition) !== 3) ? 'hidden' : '' },
            { text: translations('inventory.appropriate_order_date'), value: 'predict_order_status', class: (Number(checkSelectedCondition) !== 0 && Number(checkSelectedCondition) !== 3) ? 'hidden' : '' },
            { text: translations('inventory.inventory_turnover_rate'), value: 'inventory_turnover', class: (Number(checkSelectedCondition) !== 0 && Number(checkSelectedCondition) !== 3) ? 'hidden' : '' },
            { text: translations('inventory.inventory_movement'), sortable: false, value: 'processing' },
          ]"
          :items="stocks"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
            <template v-if="!isEmpty">
              <tr  v-for="(stock, i) in items" :key='i' data-href="">
                <td>
                  <span v-if="stock.in_stock_status" class="badge" :class="(Number(stock.in_stock_status) === 0) ? 'badge-success' : ((Number(stock.in_stock_status) === 2) ? 'badge-warning' : 'badge-danger')">
                    {{ (Number(stock.in_stock_status) === 0) ? translations('inventory.good') : ((Number(stock.in_stock_status) === 2) ? translations('inventory.outlet') : translations('inventory.bad')) }}
                  </span>
                  <span v-else> --- </span>
                  </td>
                  <td>{{ stock.maker_name }}</td>
                  <td>{{ stock.jan_code }}</td>
                  <td>{{ stock.type_number }}</td>
                  <td>{{ Number(stock.amount || 0).toLocaleString() }}</td>
                  <td>{{ Number(stock.reserve_quantity).toLocaleString() }}</td>
                  <td>{{ Number(stock.unit_price).toLocaleString() }}</td>
                  <td>{{ Number(stock.stock_cost).toLocaleString() }}</td>
                  <td>{{ stock.warehouse ? stock.warehouse : '---' }}</td>
                  <td v-if="Number(checkSelectedCondition) === 0 || Number(checkSelectedCondition) === 3">{{ stock.date_out_stock && stock.order_date ? $invoiceTools.formatDate(stock.date_out_stock ? stock.date_out_stock : stock.order_date) : '---' }}</td>
                  <td v-if="Number(checkSelectedCondition) === 0 || Number(checkSelectedCondition) === 3">
                    <span v-if="Number(stock.predict_order_status) === 1" class="badge badge-pill badge-primary">
                      {{ translations('inventory.normally') }}
                    </span>
                    <span v-else-if="Number(stock.predict_order_status) === 2" class="badge badge-pill badge-yellow">
                      {{ translations('inventory.order_required') }}
                    </span>
                    <span v-else-if="Number(stock.predict_order_status) === 3" class="badge badge-pill badge-danger">
                      {{ translations('inventory.stock_out') }}
                    </span>
                    <span v-else>
                      ---
                    </span>
                </td>
                <td v-if="Number(checkSelectedCondition) === 0 || Number(checkSelectedCondition) === 3">{{ stock.inventory_turnover + ' %'}}</td>
                <td>
                  <button
                    v-if="checkMoveProduct(stock)"
                    class="btn btn-primary btn-sm" type="button"
                    @click="moveWarehouse(stock)"
                    :disabled="Number(selectedCheckCondition) === 3"
                  >
                    {{translations('inventory.inventory_movement')}}
                  </button>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr class="odd">
                <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
              </tr>
            </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <ArchiveStockDownloadModal :csvFieldIndex="csvFieldIndex" :items="items" />
    <ArchiveStockClosingModal />
    <ArchiveStockMoveModal @reload-page="closeModalReloadPage" :date="referenceAt" :condition="selectedCondition" :warehouses="master_mywarehouses_old" :currentStock="selectedStock" />
    <ProductsConstructModal @reload-page="closeModalReloadPage" />
    <DetachProductSetsContructModal :warehouse-id="warehouse_id" :condition-id="selectedCondition" />
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ArchiveStockDownloadModal from '@/components/ArchiveStockDownloadModal'
import ArchiveStockClosingModal from '@/components/ArchiveStockClosingModal'
import ArchiveStockMoveModal from '@/components/ArchiveStockMoveModal'
import ProductsConstructModal from '@/components/ProductsConstructModal'
import DetachProductSetsContructModal from '@/components/DetachProductSetsContructModal'
import { saveAs } from 'file-saver'
import { Condition } from '@/constants'
import { mapState } from 'vuex'

var Papa = require('papaparse')
var encoding = require('encoding-japanese')

export default {
  name: 'ArchiveStock',
  props: {},
  components: {
    VueElementLoading,
    ArchiveStockDownloadModal,
    ArchiveStockClosingModal,
    ArchiveStockMoveModal,
    ProductsConstructModal,
    DetachProductSetsContructModal
  },
  watch: {
    page () {
      this.triggerFilter()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountStock')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    },
    dtSearch (v) {
      this.$storage.set('ArchiveStock:dtSearch', v) // KEEP KEYWORD
    },
    selectedCheckCondition (newValue) {
      if (newValue === Condition.ALL) {
        this.selectedConditions = []
      }
    }
  },
  data () {
    return {
      dtSearch: this.$storage.get('ArchiveStock:dtSearch') || '',
      isLoading: false,
      isSearching: false,
      warehouse: '',
      warehouse_id: 0,
      in_stock: 'exclude',
      stocks: [],
      isEmpty: false,
      isEmptyMsg: '',
      referenceAt: this.$invoiceTools.getCurrentDate(),
      displayAll: false,
      // tempDateField: '',
      selectedStock: null,
      csvFieldIndex: [], // FOR MODAL (OUT)
      items: [], // FOR MODAL (IN)
      old_jan: '',
      old_warehouse_id: 0,
      new_jan: '',
      jan_change_quantity: 0,
      jan_change_done: true,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      totalAmount: 0,
      sumTotalQuantity: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      replacementAt: this.$invoiceTools.getCurrentDate(),
      conditions: [
        { id: 'good', name: '良品', value: 0 },
        { id: 'bad', name: '不良品', value: 1 },
        { id: 'outlet', name: 'アウトレット', value: 2 }
      ],
      checkConditions: [
        { id: 'all', name: '全て', value: 3 },
        { id: 'choice', name: '選択', value: 4 }
      ],
      selectedCondition: 0,
      selectedConditions: [],
      selectedCheckCondition: 3,
      checkSelectedCondition: null,
      allowedCostDownload: 0
    }
  },
  created: async function () {
    this.$store.dispatch('Master/checkMywarehousesStock')
    this.$store.dispatch('Master/checkMywarehouses')

    let storedFilter = this.$storage.get('ArchiveStockParam')
    if (storedFilter) {
      this.selectedCondition = storedFilter.condition
      if (Number(storedFilter.condition) === Condition.ALL) {
        this.selectedCheckCondition = storedFilter.condition
      } else {
        Array.isArray(storedFilter.condition) ? this.selectedConditions = storedFilter.condition : this.selectedConditions.push(storedFilter.condition)
        this.selectedCheckCondition = Condition.CHOICE
      }
      this.referenceAt = storedFilter.reference_at
      this.in_stock = storedFilter.in_stock
      this.warehouse_id = parseInt(storedFilter.warehouse_id)
      this.old_warehouse_id = storedFilter.old_warehouse_id
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
    }

    this.setItems() // FOR CSV
    this.getUser()
  },
  mounted: function () {
    this.selectStock(this.in_stock)
    const self = this
    window.$('#productsConstructModal').on('hidden.bs.modal', function (e) {
      if (self.isLoading) self.initList()
      self.isLoading = false
    })
    window.$('#ArchiveStockMoveModal').on('hidden.bs.modal', function (e) {
      if (self.isLoading) self.initList()
      self.isLoading = false
    })
    this.setItems() // FOR CSV
  },
  computed: {
    ...mapState(['currentLanguage']),
    isAdmin: function () {
      return this.$store.getters['User/isAdmin']
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehousesStock']
    },
    master_mywarehouses_old () {
      return this.$store.getters['Master/getMywarehouses']
    },
    translatedConditions () {
      return this.conditions.map(condition => {
        return {
          id: condition.id,
          name: this.translations(`inventory.${condition.id}`),
          value: condition.value
        }
      })
    },
    translatedCheckConditions () {
      return this.checkConditions.map(condition => {
        return {
          id: condition.id,
          name: this.translations(`inventory.${condition.id}`),
          value: condition.value
        }
      })
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    checkMoveProduct (stock) {
      return Number(stock.warehouse_id) !== -1 &&
        (Number(stock.bill_to_id) === 0 ||
          Number(stock.in_stock_status) === 0 ||
          Number(stock.processing) === 0
        )
    },
    closeModalReloadPage (isLoading) {
      this.isLoading = isLoading
    },
    numbers (target) {
      this[target] = this[target].toString().replace(/[^0-9]/g, '')
    },
    setItems () {
      this.items.push({ id: 0, name: this.translations('inventory.division'), key: 'in_stock_status' })
      this.items.push({ id: 1, name: this.translations('inventory.maker'), key: 'maker_name' })
      this.items.push({ id: 2, name: this.translations('inventory.jan_code'), key: 'jan_code' })
      this.items.push({ id: 3, name: this.translations('inventory.model'), key: 'type_number' })
      this.items.push({ id: 4, name: this.translations('inventory.available_quantity'), key: 'amount' })
      this.items.push({ id: 5, name: this.translations('inventory.reserve_quantity'), key: 'reserve_quantity' })
      this.items.push({ id: 6, name: this.translations('inventory.total'), key: 'total_quantity' })
      this.items.push({ id: 7, name: this.translations('inventory.unit_price'), key: 'unit_price' })
      this.items.push({ id: 8, name: this.translations('inventory.inventory_cost'), key: 'stock_cost' })
      this.items.push({ id: 9, name: this.translations('inventory.warehouse'), key: 'warehouse' })
      this.items.push({ id: 10, name: this.translations('inventory.order_date'), key: 'date_out_stock' })
      this.items.push({ id: 11, name: this.translations('inventory.appropriate_order_date'), key: 'predict_order_status' })
      this.items.push({ id: 12, name: this.translations('inventory.inventory_turnover_rate'), key: 'inventory_turnover' })
    },
    export_csv () {
      const csvField = []
      const csvFieldKeys = []
      for (let i = 0; i < this.items.length; i++) {
        if (this.csvFieldIndex.indexOf(i) > -1) {
          csvField.push(this.items[i].name)
          csvFieldKeys.push(this.items[i].key)
        }
      }

      const csvData = [] // REFRESH
      for (let i = 0; i < this.stocks.length; i++) {
        const stock = this.stocks[i]
        const csvTemp = []
        for (let j = 0; j < csvFieldKeys.length; j++) {
          const key = csvFieldKeys[j]
          if (key === 'in_stock_status') {
            csvTemp.push(Number(stock[key]) === 0 ? '良品' : (Number(stock[key]) === 2 ? 'アウトレット品' : '不良品'))
          } else if (key === 'predict_order_status') {
            csvTemp.push(Number(stock[key]) === 1 ? '通常' : (Number(stock[key]) === 2 ? '発注必要' : (Number(stock[key]) === 3 ? '在庫切れ' : '')))
          } else {
            csvTemp.push(stock[key])
          }
        }

        csvData.push(csvTemp)
      }

      const csv = Papa.unparse({
        fields: csvField,
        data: csvData
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })

      const d = new Date()
      const filename = this.translations('inventory.archive_inventory') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'

      saveAs(content, filename)
    },

    moveWarehouse (value) {
      this.selectedStock = value
      window.$('#ArchiveStockMoveModal').modal('show')
    },

    selectStock (value) {
      if (value === 'all') {
        window.$('#filterByStock').text(this.translations('inventory.all'))
      } else if (value === 'exclude') {
        window.$('#filterByStock').text(this.translations('inventory.excluding_stock_0'))
      } else if (value === 'only') {
        window.$('#filterByStock').text(this.translations('inventory.stock_0_only'))
      } else if (value === 'reserve') {
        window.$('#filterByStock').text(this.translations('inventory.excluding_stock_0_reserve'))
      } else if (value === 'reserve_only') {
        window.$('#filterByStock').text(this.translations('inventory.reservation_only'))
      } else {
        window.$('#filterByStock').text(value)
      }
    },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        if (this.selectedCheckCondition === Condition.ALL) {
          this.selectedCondition = Condition.ALL
          this.checkSelectedCondition = Condition.ALL
        } else {
          if (this.selectedConditions.length < 2) {
            this.selectedCondition = this.selectedConditions[0]
            this.checkSelectedCondition = this.selectedConditions.includes(Condition.GOOD) ? Condition.GOOD : this.selectedConditions[0]
          } else {
            this.selectedCondition = this.selectedConditions
            this.checkSelectedCondition = this.selectedConditions.includes(Condition.GOOD) ? Condition.GOOD : Condition.BAD
          }
        }

        this.triggerFilter()
      }
    },

    triggerFilter () {
      if (this.displayAll) {
        this.$storage.set('stock_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }
      if (this.referenceAt === '') {
        return
      }

      // try {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      let params = {
        in_stock: this.in_stock,
        warehouse_id: this.warehouse_id,
        old_warehouse_id: this.old_warehouse_id,
        reference_at: this.referenceAt,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch,
        condition: this.selectedCondition
      }
      this.$storage.set('ArchiveStockParam', params)
      console.log('ArchiveStock:triggerFilter: ', params)
      this.$http.post(this.$api_url.stock_list_v2, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.stocks = result.list
          localStorage.setItem('visitCountStock', this.stocks.length)
          this.totalCount = Number(result.total_count)
          this.totalAmount = Number(result.total_amount)
          this.sumTotalQuantity = Number(result.sum_total_quantity)
        } else {
          this.stocks = []
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('ArchiveOrders:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // triggerDateFilter () {
    //   if (this.referenceAt !== this.tempDateField) {
    //     this.triggerFilter()
    //   }
    // },
    // changeSearch (e) {
    //   this.$storage.set('ArchiveStock:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    changeJanCode () {
      const self = this
      if ((!this.old_jan || !this.new_jan) || this.old_jan === this.new_jan) {
        this.$toastr.warning('JANコードが正しくありません', '')
        return false
      }

      let sumAmount = 0
      this.stocks.forEach(function (row) {
        if (row.in_stock_status === 0 && row.jan_code === self.old_jan && Number(row.warehouse_id) === self.old_warehouse_id) { // 1:良品
          sumAmount = sumAmount + row.amount
        }
      })

      this.jan_change_done = false // LOCK BUTTON

      const params = {
        old_jan: this.old_jan,
        old_warehouse_id: this.old_warehouse_id,
        new_jan: this.new_jan,
        quantity: this.jan_change_quantity,
        replacement_at: this.replacementAt
      }

      this.$http.post(this.$api_url.inventory_change_jan, params).then(function (response, error) {
        if (response && response.data.status) {
          self.initList()
          self.$toastr.success('JANの貼り替えが完了しました', '')
        } else {
          self.$toastr.error('JANの貼り替えに失敗しました', 'エラー')
        }
      }).finally(() => {
        self.jan_change_done = true // UNLOCK BUTTON
      })
    },
    getUser () {
      this.$http.post(this.$api_url.account_details).then(response => {
        const result = response.data
        if (result.status) {
          this.allowedCostDownload = result.details.allow_cost_download
        }
      })
    },
    openModalDetachSet () {
      if (this.warehouse_id) window.$('#detachProductSetsConstructModal').modal('show')
      else this.$toastr.error(this.translations('inventory.message_error_choice_warehouse'))
    },
    submitSearch () {
      this.initList()
    },
    checkOpenCondition () {
      return this.selectedCheckCondition !== Condition.CHOICE
    },
    checkOpenSubmit () {
      return (this.selectedCheckCondition === Condition.CHOICE && this.selectedConditions.length === 0)
    },
    checkOpenDetachSet () {
      if (this.selectedCheckCondition === Condition.ALL) {
        return true
      } else {
        return this.selectedConditions.length !== 1
      }
    }
  }
}
</script>

<style>
#tbl-stocks_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
